export const GET_REPORTS = "GET_REPORTS";
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS";
export const GET_REPORTS_FAIL = "GET_REPORTS_FAIL";
export const GET_REPORT_CALL = "GET_REPORT_CALL";
export const GET_REPORT_CALL_SUCCESS = "GET_REPORT_CALL_SUCCESS";
export const GET_REPORT_CALL_FAIL = "GET_REPORT_CALL_FAIL";
export const RESET_MESSAGE = "RESET_MESSAGE";
export const RESET_MESSAGE_ERROR = "RESET_MESSAGE_ERROR";
